import React, { useEffect, useRef, useState } from "react";
import { Col, Dropdown, Modal, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { people, post } from "../../config/imagesLink";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios, { enableAlgoKey } from "../../API/axios";
import { ShimmerThumbnail } from "react-shimmer-effects";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { GridCardSkeleton } from "@skeleton";
import ModalForGuest from "../ModalForGuest";
import CompanyInteraction from "./CompanyInteraction";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Helmet } from "react-helmet";
import PeopleFeedAds from "../People/PeopleFeedAds";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";

const Companies = () => {
  const options = [
    { value: "apple", label: "Apple" },
    { value: "banana", label: "Banana" },
    { value: "cherry", label: "Cherry" },
    { value: "grape", label: "Grape" },
  ];
  const guestModeData = localStorage.getItem("guestMode");
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const companyRecommendationsIds = localStorage.getItem("companyRecommendationsIds");

  const getTabFromRoute = (routeTab) => {
    const tabKey = (routeTab || "").toLowerCase();
    return tabKey === "recommendation" ? "recommendation" : "all";
  };

  const navigate = useNavigate();
  const { tab: routeTab } = useParams();
  const initialTab = getTabFromRoute(routeTab);
  const [activeTab, setActiveTab] = useState(initialTab);
  const activeTabRef = useRef(initialTab);

  console.log("🏢 Companies component mounted! Guest mode:", guestModeData !== "true" ? "NO" : "YES", { sessionId, userUid });

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************Company Start  ************************//
  const [isLoading, setIsLoading] = useState(initialTab !== "recommendation");
  const [companyList, setcompanyList] = useState([]);
  const [searchcompanyList, setSearchcompanyList] = useState([]);
  const [nextBatchLoading, setNextBatchLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [isError, setIsError] = useState(false);
  const [searchUserName, setSearchUserName] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const requestIdRef = useRef(0);

  const [debouncedSearch, setDebouncedSearch] = useState(searchUserName);

  //************************ Company Recommendations Start  ************************//
  const [recommendationPage, setRecommendationPage] = useState(1);
  const [recommendationTotalPages, setRecommendationTotalPages] = useState(1);
  const [recommendationList, setRecommendationList] = useState([]);
  const [recommendationLoading, setRecommendationLoading] = useState(
    initialTab === "recommendation"
  );
  const [recommendationHasMore, setRecommendationHasMore] = useState(true);
  const [recommendationNextBatchLoading, setRecommendationNextBatchLoading] = useState(false);
  const [recommendationError, setRecommendationError] = useState(false);
  const recommendationRequestIdRef = useRef(0);

  const normalizeRecommendationCompany = (company) => ({
    ...company,
    compUid: company.compUid ?? company.companyUid,
    compName: company.compName ?? company.companyName,
    logoImage: company.logoImage ?? company.companyLogo,
    backGroundImage: company.backGroundImage ?? company.backgroundImage ?? "",
    follwersCounts: company.follwersCounts ?? company.followersCount ?? 0,
    nameTag: company.nameTag ?? company.title ?? "",
    industryName: company.industryName ?? company.city ?? "",
    slug: company.slug ?? company.companyName,
    isOwned: company.isOwned ?? false,
  });

  const getCompanyRecommendations = (page) => {
    setRecommendationNextBatchLoading(true);
    const currentRequestId = ++recommendationRequestIdRef.current;
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 24,
      companyRecommendationsIds: companyRecommendationsIds,
      enableAlgo: enableAlgoKey,
    };

    axios
      .post(`Feature/CompanyRecommendations`, data)
      .then((response) => {
        if (currentRequestId !== recommendationRequestIdRef.current) return;

        setRecommendationError(false);
        setRecommendationLoading(false);

        const res = response.data.responseData;
        const newPosts = (res?.dataList || []).map(normalizeRecommendationCompany);
        const totalPages = res?.paging?.totalPages ?? 1;

        setRecommendationTotalPages(totalPages);
        setRecommendationList((prev) => {
          if (page === 1) {
            return newPosts;
          }
          const companySet = new Set(prev?.map((company) => company?.compUid));
          const uniqueNewPosts = newPosts.filter(
            (company) => !companySet.has(company?.compUid)
          );
          return [...prev, ...uniqueNewPosts];
        });

        setRecommendationHasMore(page < totalPages);
        setRecommendationNextBatchLoading(false);
      })
      .catch((error) => {
        if (currentRequestId !== recommendationRequestIdRef.current) return;
        if (error.response && error.response.status === 404) {
          setRecommendationError(true);
        } else {
          console.log("Company recommendations API error:", error);
        }
        setRecommendationLoading(false);
        setRecommendationNextBatchLoading(false);
      });
  };

  const resetRecommendationState = () => {
    setRecommendationPage(1);
    setRecommendationList([]);
    setRecommendationHasMore(true);
    setRecommendationLoading(true);
    setRecommendationError(false);
    recommendationRequestIdRef.current++;
  };

  const applyTabFromRoute = () => {
    const tab = getTabFromRoute(routeTab);
    if (activeTabRef.current === tab) return;

    if (tab === "recommendation") {
      resetRecommendationState();
    }

    activeTabRef.current = tab;
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleTabChange = (tab) => {
    navigate(tab === "recommendation" ? "/Companies/Recommendation" : "/Companies/All");
  };

  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  useEffect(() => {
    applyTabFromRoute();
  }, [routeTab]);
  //************************ Company Recommendations End  ************************//

  useEffect(() => {
    if (searchUserName === "") {
      setDebouncedSearch("");
      return;
    }
    const handler = setTimeout(() => {
      setDebouncedSearch(searchUserName);
    }, 1000);

    return () => clearTimeout(handler);
  }, [searchUserName]);

  const getCompanyList = (page, debouncedSearch) => {
    setNextBatchLoading(true);
    const currentRequestId = ++requestIdRef.current;

    const data = {
      deviceType: "Web",
      pageNumber: page,
      pageSize: 24,
    };

    axios
      .post(`Company/GetAllCompaniesList?Search=${debouncedSearch}`, data)
      .then((response) => {
        if (currentRequestId !== requestIdRef.current) return;

        setIsLoading(false);
        console.log("response", response);

        if (!response || !response.data || !response.data.responseData) {
          setcompanyList([]);
          setNoRecordsFound(true);
          setHasMoreData(false);
          setNextBatchLoading(false);
          return;
        }

        const newPosts = response.data.responseData.companiesList || [];
        const totalPages = response.data.responseData.paging?.totalPages || 0;

        if (!newPosts || newPosts.length === 0) {
          if (page === 1) {
            setcompanyList([]);
            setNoRecordsFound(true);
          }
          setHasMoreData(false);
          setNextBatchLoading(false);
          return;
        }

        setIsError(false);
        setNoRecordsFound(false);
        setTotalPages(totalPages);

        const isSearch = debouncedSearch !== "";
        setIsSearchMode(isSearch);

        if (isSearch) {
          setcompanyList([]);
          setSearchcompanyList(newPosts);
        } else {
          setSearchcompanyList([]);
          setcompanyList((prev) => {
            const postSet = new Set(prev?.map((post) => post?.compUid));
            const uniqueNewPosts = newPosts.filter(
              (post) => !postSet.has(post?.compUid)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }

        setHasMoreData(page < totalPages);
        setNextBatchLoading(false);
      })
      .catch((error) => {
        if (currentRequestId !== requestIdRef.current) return;
        setIsLoading(false);
        setNextBatchLoading(false);
        setNoRecordsFound(true);
        console.log("Companies API error:", error);
      });
  };


  const getUserListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
      result.push(post);
      // Insert AdComponent after every 12 posts
      if ((index + 1) % 12 === 0) {
        result.push({ isAd: true }); // Add a placeholder object for ads
      }
    });
    return result;
  };

  const CompanyWithAds = getUserListWithAds(companyList);
  const RecommendationWithAds = getUserListWithAds(recommendationList);
  const isRecommendationTab = activeTab === "recommendation";
  const displayIsLoading = isRecommendationTab ? recommendationLoading : isLoading;
  const displayIsError = isRecommendationTab ? recommendationError : isError;
  const displayNextBatchLoading = isRecommendationTab
    ? recommendationNextBatchLoading
    : nextBatchLoading;
  const displayHasMore = isRecommendationTab ? recommendationHasMore : hasMoreData;
  const refreshCompanyList = isRecommendationTab
    ? () => getCompanyRecommendations(1)
    : () => getCompanyList(1, debouncedSearch);


         // -------------------------------------------------------------------------
      const { setIsNewsPageLoaded } = useNewsFeedStore();
  
      useEffect(() => {
          setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed
  
          return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
      }, [setIsNewsPageLoaded]);
  
      // -------------------------------------------------------------------------
  
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggleDropdown = (index) => {
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    setPage(1);
    setcompanyList([]);
    setSearchcompanyList([]);
    setHasMoreData(true);
    setNoRecordsFound(false);
  }, [debouncedSearch]);

  useEffect(() => {
    if (activeTab !== "all") return;
    if (hasMoreData || page === 1) {
      getCompanyList(page, debouncedSearch);
    }
  }, [page, debouncedSearch, activeTab]);

  useEffect(() => {
    if (activeTab !== "recommendation") return;
    if (recommendationHasMore || recommendationPage === 1) {
      getCompanyRecommendations(recommendationPage);
    }
  }, [recommendationPage, activeTab]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        if (activeTab === "all" && hasMoreData && !nextBatchLoading) {
          setPage((prev) => prev + 1);
        } else if (
          activeTab === "recommendation" &&
          recommendationHasMore &&
          !recommendationNextBatchLoading
        ) {
          setRecommendationPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, [
    activeTab,
    hasMoreData,
    recommendationHasMore,
    nextBatchLoading,
    recommendationNextBatchLoading,
  ]);
  //************************Company End  ************************//
  //************************ Follow User Start  ************************//
  const [isfollowed, setIsfollowed] = useState("");
  const [followedCompanies, setFollowedCompanies] = useState({});
  console.log("followedCompanies", followedCompanies);

  //************************ Follow Company Start  ************************//

  const FollowCompany = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      uiD_ID: id,
    };
    try {
      await axios.post("Entity/Follow/Company", data).then((resData) => {
        console.log("followed");
        getCompanyList();
        // setIsfollowed(true);
        setFollowedCompanies((prev) => ({ ...prev, [id]: true }));
        setToastMessage(resData.data.message);
        setShowToast(true);
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Follow Company End  ************************//

  //************************ UnFollow Company Start  ************************//
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const [compUID, setCompUID] = useState("");
  const UnFollow = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      uiD_ID: compUID,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("Entity/Unfollow/Company", data).then((resData) => {
        console.log("resData", resData);
        getCompanyList();
        // toast.success(resData.data.message);
        setIsfollowed(false);
        setFollowedCompanies((prev) => ({ ...prev, [compUID]: false }));
        setToastMessage(resData.data.message);
        setShowToast(true);
        handleCloseModal();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ UnFollow Company End  ************************//

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [showModal]);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    scrollToTop();
  }, []);

  const renderCompanyCard = (item, index, keyPrefix = "company") => {
    if (item.isAd) {
      return (
        <Col md={12} key={`${keyPrefix}-ad-${index}`}>
          <PeopleFeedAds />
        </Col>
      );
    }

    return (
      <Col md={6} key={`${keyPrefix}-${item.compUid}-${index}`} className="d-flex align-items-stretch">
        <div className="PeopleCard" style={{ width: "100%" }}>
          <div className="PeopleCardHeader">
            <img
              src={
                item.backGroundImage === null || item.backGroundImage === ""
                  ? people.background
                  : item.backGroundImage
              }
              alt=""
              width="100%"
              height="120px"
            />
            <div className="overlay"></div>
            <div className="centerAlignment">
              <Link to={item.compName ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                <div className="">
                  <img
                    src={item.logoImage === null ? people.DefaultProfile : item.logoImage}
                    alt=""
                    srcset=""
                    style={{ borderRadius: "50px" }}
                    width={50}
                    height={50}
                  />
                </div>
              </Link>
              <div className=" d-block d-md-flex align-items-baseline justify-content-between">
                <div className=" ">
                  <div className="mainCardText mb-0">
                    <Link to={item.compName ? `/Company/${item.compUid}/${item.compName}` : `/Company/${item.compUid}`}>
                      <h1>{item.compName}</h1>
                    </Link>
                  </div>
                  {item.follwersCounts >= 10 ? (
                    <div className="cardSubTextC mt-2">
                      <h1>{item.follwersCounts} {t("Companies.Followers")}</h1>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mainCardText">
                    <h1>{item.nameTag}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="PeopleCardContainer p-2  d-flex align-items-baseline justify-content-between">
            <div>
              <div className="mainCardText"></div>
              <div className="cardSubText">
                <h1>{item.industryName}</h1>
              </div>
            </div>
            <div
              className="follower-button d-flex flex-column align-items-center"
              style={{ width: "100px" }}
            >
              {item.isOwned === false ? (
                <CompanyInteraction
                  item={item}
                  isCompanyFollowed={item.isFollowedByYou}
                  index={index}
                  followedCompanies={followedCompanies}
                  setFollowedCompanies={setFollowedCompanies}
                  getCompanyList={refreshCompanyList}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </Col>
    );
  };

  return (
    <>
      <Helmet>
        <title>Companies | Welinkjobs</title>
        <meta name="description" content="Take your career to new heights. Explore top companies and exciting job openings on our portal. Your future starts here." />
        {/* <meta name="keywords" content="react, meta tags, seo" /> */}
        {/* <meta name="author" content="Your Name" /> */}
        <meta property="og:title" content="Welinkjobs, Your Career Hub: Discover Top Companies" />
        <meta property="og:description" content="Take your career to new heights. Explore top companies and exciting job openings on our portal. Your future starts here." />
        {/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
        <meta property="og:url" content="https://welinkjobs.com/Companies" />
      </Helmet>
      <div className="friend-main-container mt-3">
        <Row>
          <div className="headerSection  d-block d-md-flex justify-content-between">
            <Col md={7}>
              <div className="friendsHeaderText">
                <h1>{t("Companies.Companies")}</h1>
              </div>
            </Col>
            {activeTab === "all" && (
              <Col md={5}>
                <div>
                  <input
                    type="email"
                    className="form-control p-2"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder={t("Companies.Search Company")}
                    onChange={(e) => {
                      setSearchUserName(e.target.value);
                    }}
                    value={searchUserName}
                  />
                </div>
              </Col>
            )}
          </div>
        </Row>
        <div className="tabButton d-flex p-2 w-100 me-2 connectionTab">
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "all"}
            className={`text-center border-0 bg-transparent p-0 ${activeTab === "all" ? "activeTab" : ""}`}
            onClick={() => handleTabChange("all")}
          >
            <p className="f-14 tabName">{t("People.ALL")}</p>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "recommendation"}
            className={`text-center border-0 bg-transparent p-0 ${activeTab === "recommendation" ? "activeTab" : ""}`}
            onClick={() => handleTabChange("recommendation")}
          >
            <p className="f-14 tabName">{t("People.Recommendation")}</p>
          </button>
        </div>
        <div className="frindsCardContainer">
          <Row>
            {displayIsLoading ? (
              <GridCardSkeleton count={6} cardHeight={200} />
            ) : displayIsError ? (
              <div className="d-flex justify-content-center align-items-center mt-5">
                <img src={post.errorSmall} alt="404 Not Found" width={200} />
              </div>
            ) : isRecommendationTab ? (
              RecommendationWithAds.length === 0 ? (
                <div className="d-flex justify-content-center align-items-center mt-5">
                  <img src={post.errorSmall} alt="No recommendations found" width={200} />
                </div>
              ) : (
                RecommendationWithAds.map((item, index) =>
                  renderCompanyCard(item, index, "company-rec")
                )
              )
            ) : isError || noRecordsFound ? (
              <div className="d-flex justify-content-center align-items-center mt-5">
                <img src={post.errorSmall} alt="404 Not Found" width={200} />
              </div>
            ) : searchcompanyList.length === 0 ? (
              CompanyWithAds.map((item, index) =>
                renderCompanyCard(item, index, "company")
              )
            ) : (
              searchcompanyList.map((item, index) =>
                renderCompanyCard(item, index, "company-search")
              )
            )}
            {activeTab === "all" && isSearchMode ? (
              !isLoading && searchcompanyList.length === 0 && (
                <div className="text-center mt-4">
                  <img src={post.errorSmall} alt="Result Not Found" width="180" />
                  <p></p>
                </div>
              )
            ) : (
              !displayIsLoading &&
              !displayNextBatchLoading &&
              !displayHasMore &&
              ((isRecommendationTab && recommendationList.length > 0) ||
                (!isRecommendationTab &&
                  (companyList.length > 0 || searchcompanyList.length > 0))) && (
                <p className="text-center">{t("Newsfeed.No more data available")}</p>
              )
            )}
            {displayNextBatchLoading && (
              <div className="text-center">
                <img src={post?.loader} width={50} />
              </div>
            )}
          </Row>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are you sure you want to unfollow")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="closebtn"
                  onClick={() => UnFollow()}
                >
                                    {t("Recommendations.Unfollow")}  
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {followModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Companies;
